import { render } from "./PLEFooter.vue?vue&type=template&id=e98f5316"
import script from "./PLEFooter.vue?vue&type=script&lang=js"
export * from "./PLEFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__